<div class="standard-dialog dialog-refund-confirm-wrapper">
  <fa-icon [icon]='faTimes' class="close-icon" (click)="onCancel()"></fa-icon>
  <fa-icon [icon]='faTriangleExclamation' class="warning-icon"></fa-icon>
  <p class="title">¿Estás seguro/a de que quieres la devolución de las entradas?</p>
  <p class="subtitle">Vas a devolver las entradas de este pedido de forma permanente</p>
  <div class="buttons-wrapper">
    <button class="action-button secondary-button" (click)="onCancel()">Cancelar</button>
    <button class="action-button primary-button" (click)="onConfirm()">Devolver dinero</button>
  </div>
</div>